/** Public store listings for LuvLust (marketing site + CTAs). */
export const APP_STORE_URL =
  'https://apps.apple.com/in/app/luvlust-couple-quiz/id6747910861';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.starlit.couplegame';
